// Fetch Company Details
export const FETCH_COMPANY_DETAILS = "FETCH_COMPANY_DETAILS"
export const FETCH_COMPANY_DETAILS_SUCCESS = "FETCH_COMPANY_DETAILS_SUCCESS"
export const FETCH_COMPANY_DETAILS_FAIL = "FETCH_COMPANY_DETAILS_FAIL"

// Update Company Details
export const UPDATE_COMPANY_DETAILS = "UPDATE_COMPANY_DETAILS"
export const UPDATE_COMPANY_DETAILS_SUCCESS = "UPDATE_COMPANY_DETAILS_SUCCESS"
export const UPDATE_COMPANY_DETAILS_FAIL = "UPDATE_COMPANY_DETAILS_FAIL"

// Create Company Details (for first time setup)
export const CREATE_COMPANY_DETAILS = "CREATE_COMPANY_DETAILS"
export const CREATE_COMPANY_DETAILS_SUCCESS = "CREATE_COMPANY_DETAILS_SUCCESS"
export const CREATE_COMPANY_DETAILS_FAIL = "CREATE_COMPANY_DETAILS_FAIL"
